<template>
  <div id="app">
    <!-- <div > -->
    <main-nav-bar class="position-sticky" @search="setSearchPhrase($event)"/>
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <!-- </div> -->
    <router-view :model="searchPhrase"/>
  </div>
</template>

<script>
import MainNavBar from "@/components/MainNavBar.vue";

export default {
  name: "App",
  components: {
    MainNavBar,
  },
  data() {
    return {
      searchPhrase: null
    }
  },
  methods: {
    setSearchPhrase(phrase) {
      this.searchPhrase = phrase;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/maxico.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  background: radial-gradient(
        circle farthest-side at 0% 50%,
        #ccc 23.5%,
        rgba(240, 166, 17, 0) 0
      )
      21px 30px,
    radial-gradient(
        circle farthest-side at 0% 50%,
        #314043 24%,
        rgba(240, 166, 17, 0) 0
      )
      19px 30px,
    linear-gradient(
        #ccc 14%,
        rgba(240, 166, 17, 0) 0,
        rgba(240, 166, 17, 0) 85%,
        #ccc 0
      )
      0 0,
    linear-gradient(
        150deg,
        #ccc 24%,
        #000 0,
        #000 26%,
        rgba(240, 166, 17, 0) 0,
        rgba(240, 166, 17, 0) 74%,
        #314043 0,
        #314043 76%,
        #ccc 0
      )
      0 0,
    linear-gradient(
        30deg,
        #ccc 24%,
        #314043 0,
        #314043 26%,
        rgba(240, 166, 17, 0) 0,
        rgba(240, 166, 17, 0) 74%,
        #314043 0,
        #314043 76%,
        #ccc 0
      )
      0 0,
    linear-gradient(90deg, #314043 2%, #efefef 0, #ccc 98%, #314043 0%) 0 0 #ccc;
  background-size: 40px 60px;
}
</style>
